module.exports = __webpack_public_path__ + "img/boom.b2d072e3.png";